import { ProfessionIcon } from './profession-icon';

export const IconPhotographer = () => (
  <ProfessionIcon bg="#F3E5F5">
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
      <path
        d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2v11z"
        stroke="#9C27B0"
        strokeWidth="1.8"
      />
      <circle cx="12" cy="13" r="4" stroke="#9C27B0" strokeWidth="1.8" />
    </svg>
  </ProfessionIcon>
);
